import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  chips: {
    display: 'flex',
    gap: theme.spacing(1),
    margin: theme.spacing(1, 0, 2),
    flexWrap: 'wrap',
  },
  ok: {
    backgroundColor: theme.palette.success ? theme.palette.success.light : '#c8e6c9',
  },
  bad: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
  section: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
  mono: {
    fontFamily: 'monospace',
    fontSize: 12,
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
}));
